import classNames from 'classnames';

import { Typography } from '@/shared/components/atoms';
import { IIconWithTitleDescriptionProps } from '@/shared/components/atoms/IconWithTItleDescription/IconWithTitleDescription';

// TODO: types in another file
interface IProps {
  item: IIconWithTitleDescriptionProps;
  containerClassName?: string;
}
const IconWithTitleDescription: React.FC<IProps> = ({
  item: {
    titleTypography = {
      variant: 'caption',
    },
    descriptionTypography = {
      variant: 'body1',
      weight: 'semiBold',
    },
    iconGap = 'gap-8',
    ...rest
  },
  containerClassName,
}) => {
  return (
    <div className={classNames('flex', iconGap, containerClassName)}>
      {rest?.icon && (
        <span
          className={classNames(
            'flex text-primary-default',
            rest.iconAlignment === 'center' && 'items-center',
            rest.iconContainerClassName
          )}
        >
          {rest.icon}
        </span>
      )}
      <div className='flex flex-col gap-4'>
        <div className='flex items-center gap-8'>
          <Typography {...titleTypography}>
            <span>{rest.title}</span>
          </Typography>
          {rest.titleSuffix}
        </div>
        {typeof rest.description === 'string' ? (
          <Typography {...descriptionTypography}>
            <span dir={rest.dir}>{rest.description}</span>
          </Typography>
        ) : (
          rest.description
        )}
      </div>
    </div>
  );
};

export default IconWithTitleDescription;
